import router from '@/router';
import store from '@/store';
import { $deleteFromArray, $handleError, $updateOrAdd } from '@/utils';
import companyManagementService from '@Company/service/company-management.service';
import dayjs from 'dayjs';
import Vue from 'vue';

export const COMPANY = {
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    updateLoading: false,
    inviteLoading: false,
    facilitiesLoading: false,
    options: {},
  },
  getters: {
    GET_REGIONS() {
      return  [{id:1,name:'UAE',flag:'/img/uae-flag.svg'},
        {id:2,name:'UK',flag:'/img/uk-flag.svg'}];
    },
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_UPDATE_LOADING(state) {
      return state.updateLoading;
    },
    GET_FACILITIES_LOADING(state) {
      return state.facilitiesLoading;
    },
    GET_OPTIONS(state) {
      return state.options;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_INVITE_LOADING(state, value) {
      state.inviteLoading = value;
    },
    SET_UPDATE_LOADING(state, value) {
      state.updateLoading = value;
    },
    SET_FACILITIES_LOADING(state, value) {
      state.facilitiesLoading = value;
    },
    SET_OPTIONS(state, value) {
      state.options = value;
    },
  },
  actions: {
    GET({ commit, state }) {
      commit('SET_LOADING', true);
      companyManagementService
        .get(state.options)
        .then((res) => {
          commit(
            'SET_ENTRIES',
            res.data.items.map((elm) => mapCompany(elm)),
          );
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    GET_BY_ID(context, id) {
      return companyManagementService.getById(id);
    },
    UPDATE({ state, commit }, data) {
      commit('SET_UPDATE_LOADING', true);
      return companyManagementService
        .update(data)
        .then((res) => {
          $updateOrAdd(state.entries, mapCompany(res.data));

          let user = store.getters['ACCOUNT/GET_USER'];
          if (user.companyId === data.id) {
            user.company = res.data;
            store.commit('ACCOUNT/UPDATE_USER_BASIC', user);
          }

          Vue.prototype.$dialog.notify.success(
            `Company Data Successfully ${data.id ? 'Updated' : 'Added'}.`,
          );
          if (!data.id) {
            commit('SET_TOTAL', ++state.total);
          }
        })
        .catch((err) => {
          $handleError(err);
          throw err;
        })
        .finally(() => {
          commit('SET_UPDATE_LOADING', false);
        });
    },
    SUSPEND({ state }, { id, status }) {
      return companyManagementService
        .suspend(id, status)
        .then((res) => {
          $updateOrAdd(state.entries, mapCompany(res.data));
          Vue.prototype.$dialog.notify.success(
            `Company ${status ? 'Suspended' : 'Reactivated'} Successfully`,
            {
              position: 'top-right',
              timeout: 3000,
            },
          );
        })
        .catch((err) => {
          $handleError(err);
        });
    },
     DELETE({ state }, { id }) {
      return companyManagementService
        .delete(id)
        .then(() => {
          $deleteFromArray(state.entries, id);
          Vue.prototype.$dialog.notify.success(
            `Company Deleted Successfully`,
            {
              position: 'top-right',
              timeout: 3000,
            },
          );
        })
        .catch((err) => {
          $handleError(err);
        });
    },
    FETCH_FACILITIES({ commit }, companyId) {
      commit('SET_FACILITIES_LOADING', true);
      return companyManagementService
        .getFacilities(companyId)
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_FACILITIES_LOADING', false);
        });
    },
    RESEND_INVITATION({ commit  },  id){
      commit('SET_UPDATE_LOADING', true);

      return companyManagementService
        .resendInvitation(id)
        .then(() => {
          Vue.prototype.$dialog.notify.success(
            "Invitation send successfully!",
          );
          
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_UPDATE_LOADING', false);
        });
    },
    IMPERSONATE({ commit  },  id){
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true);
        companyManagementService
        .impersonate(id)
        .then((res) => {
          commit("ACCOUNT/SET_USER",res.data,{root:true});
          resolve(res.data)
        })
        .catch((err) => {
          $handleError(err);
          reject(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
      });
 
    },
    EXIT_IMPERSONATION({ commit  }){
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true);
        companyManagementService
        .exitImpersonation()
        .then((res) => {
        
          commit("ACCOUNT/SET_USER",res.data,{root:true});
          resolve(res.data)
        })
        .catch((err) => {
          $handleError(err);
          reject(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
      });
 
    }

  },
};
  

function mapCompany(company) {
  const today = dayjs(); // Current date
  const expiryDate = dayjs(company.licenseExpiryDate); // License expiry date
  const daysUntilExpiry = expiryDate.diff(today, 'day'); // Calculate difference in days

  company.daysUntilExpiry = daysUntilExpiry;
  company.isAboutToExpire = daysUntilExpiry <= 30;

  return company;
}
